var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal"}},[(_vm.stage === 1)?_c('RollCall',_vm._g({key:1},_vm.$listeners)):(_vm.stage === 2)?_c('Vote',_vm._g({key:2},_vm.$listeners)):(_vm.stage === 3)?_c('Pass',_vm._g({key:3},_vm.$listeners)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }